import { Alert } from '@/components/assistant/alert/Alert'
import { Alert as AlertType } from '@/store/alert'
import { Beneficiary } from '@/store/beneficiary'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@repo/ui/card'
import { useT } from '@repo/ui/hooks'
import { InlineCode } from '@repo/ui/inlineCode'
import { ScrollArea } from '@repo/ui/scrollArea'
import { Sheet, SheetContent, SheetHeader, SheetTrigger } from '@repo/ui/sheet'
import { sortByKey } from '@repo/ui/utils'
import { BellOff } from 'lucide-react'
import { Trans } from 'react-i18next'

export function ArchivedAlerts({
  archivedAlerts,
  beneficiaries,
}: {
  archivedAlerts: AlertType[]
  beneficiaries: Beneficiary[]
}) {
  const { t } = useT({ keyPrefix: 'assistant' })
  return (
    <Sheet>
      <SheetTrigger asChild>
        <div className="inline cursor-pointer underline">{t('yes')}</div>
      </SheetTrigger>
      <SheetContent
        side="right"
        className="m-0 flex max-h-screen min-w-fit flex-col p-0"
      >
        <SheetHeader className="border-b-primary-200 bg-primary-50 z-10 flex flex-shrink-0 border-b">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <BellOff className="h-6 w-6" />
              {t('alert.archived.title')}
            </CardTitle>
            <CardDescription>
              <Trans
                i18nKey="assistant.alert.archived.description"
                count={archivedAlerts?.length ?? 0}
                components={[
                  <InlineCode className="text-primary">
                    {archivedAlerts?.length ?? 0}
                  </InlineCode>,
                ]}
              />
            </CardDescription>
          </CardHeader>
        </SheetHeader>
        <div className="flex min-w-[330px] max-w-[620px] flex-1 flex-col overflow-hidden">
          <div className="flex max-h-[calc(100vh-12.5rem)] flex-1 flex-col overflow-hidden">
            <ScrollArea className="flex flex-col">
              <div className="flex flex-col gap-4 px-6 pb-6">
                {[...archivedAlerts]
                  ?.sort(sortByKey('statusChangedAt', 'desc'))
                  .map((alert) => {
                    const beneficiary = beneficiaries.find(
                      (b) => alert.beneficiaryId === b.id,
                    )
                    if (!beneficiary) return null
                    return (
                      <Card key={alert.id} className="border-primary-100">
                        <CardContent className="pt-4">
                          <Alert alert={alert} beneficiary={beneficiary} />
                        </CardContent>
                      </Card>
                    )
                  })}
              </div>
            </ScrollArea>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  )
}
